import React, {useCallback, useEffect, useRef, useState} from 'react';
import { Flex, Row, Skeleton} from "antd";
import style from "./TopAd.module.scss";
import {ProductListFilterModel} from "../../../product/models";
import {connect} from "react-redux";
import {getProductList} from "../../../product/actions/Product.action";
import {withRouter} from "../../../../utils/services/with-router";
import {EmptyMessage} from "../../../../shared";
import ProductCard from "../../../../shared/components/productCard/ProductCard";

const TopAdList = (props: any) => {
    const [products, setProducts] =
        useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const observerRef = useRef<IntersectionObserver | null>(null);
    const loadMoreRef = useRef(null);

    const getList = useCallback((pageNumber: number, isAppend = false) => {
        setLoading(true)
        let model:ProductListFilterModel ={
            fromIndex: ((pageNumber - 1) * 15 ).toString(),
            toIndex: (((pageNumber * 15))-1).toString(),
            fromPrice:'',
            toPrice:'',
            searchText:'',
            subCategoryId:'',
        }
        console.log(model)
        props.getProductList(model)
            .then((data: any) => {
                const newProducts = data?.payload?.data || [];
                console.log(data?.payload);
                setProducts(prev => isAppend ? [...prev, ...newProducts] : newProducts);
                setHasMore(newProducts.length === 14); // If less than 10, no more
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [getProductList]);
    useEffect(() => {
        setProducts([]);
        setPage(1);
        setHasMore(true);
        getList(1, false);
    }, [ getList]);
    useEffect(() => {
        if (loading || !hasMore) return;

        if (observerRef.current) observerRef.current.disconnect();

        observerRef.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting) {
                setPage(prev => prev + 1);
            }
        });

        if (loadMoreRef.current) {
            observerRef.current.observe(loadMoreRef.current);
        }
    }, [loading, hasMore]);

    // Load page > 1 data
    useEffect(() => {
        if (page > 1 && hasMore) {
            getList(page, true);
        }
    }, [page, getList]);
    return (
        <Flex vertical gap={"small"}>
            <Row justify={"space-between"}>
                <span className={style.CategoryTitle}> جدیدترین آگهی ها</span>
                {/* <small className={style.moreBtn}> مشاهده همه</small> */}
            </Row>


                {(products?.length === 0 && !loading) && <EmptyMessage message={"آگهی در حال حاضر موجود نیست !"}/>}
                {
                    products.map((item:any) => <ProductCard product={item}/>)
                }
            {loading && (
                <Flex vertical>
                    <Skeleton active />
                    <Skeleton active />
                </Flex>
            )}

            <div ref={loadMoreRef} style={{ height: 1 }} />

        </Flex>
    );
};

export default connect(null, {getProductList})(withRouter(TopAdList));
